import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Portal from './Portal';

export function ConfirmDeletionModal({
  open,
  onClose,
  onConfirm,
  itemName,
  warningText = 'This action is permanent and cannot be undone.',
  confirmLabel = 'Delete',
  isPending = false,
}) {
  const displayName = itemName?.trim() || 'this item';

  return (
    <Portal open={open} onClose={onClose} size="sm" hideHeader centered>
      <div className="flex flex-col items-center text-center">
        <div
          className="mb-5 text-[2.75rem] leading-none text-[var(--destructive)]"
          aria-hidden="true"
        >
          <FontAwesomeIcon icon={['fas', 'triangle-exclamation']} />
        </div>
        <h3 className="m-0 text-2xl font-bold leading-tight text-[#121212]">
          Confirm Deletion
        </h3>
        <p className="mt-3 mb-0 text-base leading-relaxed text-[#121212]">
          Are you sure you want to delete <strong>{displayName}</strong>?
        </p>
        {warningText ? (
          <p className="mt-2 mb-0 text-sm leading-relaxed text-[var(--muted-foreground)]">
            {warningText}
          </p>
        ) : null}
        <div className="mt-8 grid w-full grid-cols-2 gap-3">
          <button
            type="button"
            className="inline-flex min-h-11 items-center justify-center rounded-[var(--bethere-radius-md)] border-2 border-primary bg-white px-4 font-bold text-primary transition-all hover:-translate-y-px hover:bg-primary hover:text-primary-foreground"
            onClick={onClose}
            disabled={isPending}
          >
            Cancel
          </button>
          <button
            type="button"
            className="inline-flex min-h-11 items-center justify-center rounded-[var(--bethere-radius-md)] border border-transparent bg-[var(--destructive)] px-4 font-bold text-white transition-all hover:-translate-y-px hover:brightness-110 disabled:opacity-60"
            onClick={onConfirm}
            disabled={isPending}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Portal>
  );
}
